import React, { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './AuthContext';
import Login from './Login';
import Main from './Main';
import HealthSherpaApp from './HealthSherpaApp';
import CalendarApp from './CalendarApp';
import ReloginBox from './ReloginBox';
import { safeNext } from './nextUrl';

// 5.17.0: ?healthsherpa=1 -> the HealthSherpa page as its own tab (after the same login; the in-page
// login keeps the address, so the param survives it). Read once per page load.
const isHealthSherpaTab = (() => {
  try { return new URLSearchParams(window.location.search).get('healthsherpa') === '1'; } catch (_e) { return false; }
})();
// 5.32.0: /?calendar=1 = the Calendar + Tasks page in its own tab (CalendarApp)
const isCalendarTab = (() => {
  try { return new URLSearchParams(window.location.search).get('calendar') === '1'; } catch (_e) { return false; }
})();

// 5.42.0: /?next=/acord/... = ACORD sent a signed-out / expired visitor here (a form deep link). Read once per page load.
const NEXT = safeNext(window.location.search);

function AppInner() {
  const { user, loading, refreshUser } = useAuth();
  const [loggedIn, setLoggedIn] = useState(!!user);
  const signedIn = !loading && (loggedIn || !!user);

  // 5.42.0 signed in (now, or already) -> back to the ACORD address. ACORD always clears its token before sending
  // someone here, so this can't loop.
  useEffect(() => { if (NEXT && signedIn) window.location.replace(NEXT); }, [signedIn]);

  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#888' }}>Loading...</div>;
  if (!loggedIn && !user) return <Login onLogin={() => setLoggedIn(true)} />;
  if (NEXT) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#888' }}>Opening ACORD…</div>;
  return (
    <>
      {isHealthSherpaTab ? <HealthSherpaApp user={user} /> : isCalendarTab ? <CalendarApp /> : <Main />}
      <ReloginBox allowSignOut onSignedIn={refreshUser} />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
